import React from 'react'
import styled from 'styled-components'
import { Icon } from 'components/atoms'

/**
 * primary component
 */
export const Container = styled.div`
  position: relative;
  box-shadow: 1px 2px 1px 0 ${ (props) => props.theme.colors.boxShadow };
  z-index: 0;
  ${ (props) =>
    props.active &&
    `&::before {
      box-shadow: inset 6px 0 0 0 ${ props.theme.colors['aok-gruen'] };
      position: absolute;
      top: 0;
      left: 0;
      width: 6px;
      height: 100%;
      content: '';
      z-index: 1;
    }` }

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    &:hover::before {
      box-shadow: inset 6px 0 0 0 ${ (props) => props.theme.colors['aok-gruen'] };
      position: absolute;
      top: 0;
      left: 0;
      width: 6px;
      height: 100%;
      content: '';
      z-index: 1;
    }
  }

  .result-tile-small-copy {
    font-size: 16px;
    line-height: 23px;
  }

  .copy-light {
    color: ${ (props) => props.theme.colors['panel-inner-border'] };
  }

  > a {
      text-decoration: none;

      h4:hover {
          text-decoration: underline;
      }
  }

  .result-tile-header {
      position: relative;
      top: initial;
      left: initial;
      background: ${ (props) => props.theme.colors.weiss };
      display: flex;
      flex-wrap: wrap;
      padding: 15px 20px;

      ${ (props) => props.clickAbleHeader && `&:hover { cursor: pointer; }` }
      ${ (props) =>
        props.isMobile &&
        props.clickAbleHeader &&
        `&:hover { cursor: pointer; }` }

      @media ${ (props) => props.theme.breakpoints.devices.min.sm }, print {
        padding: 15px 30px;

        &:hover {
          background: ${ (props) => props.theme.colors.hintergrundPrio2 };
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;

        .headline {
          position: relative;
          padding-right: 30px;

          &.one-add-value {
            padding-right: 170px;
          }

          &.two-add-value {
            padding-right: 285px;
          }

          h4 {
            font-size: 22px;
            line-height: 26px;
            color: ${ (props) => props.theme.colors['aok-gruen'] };
            margin: 5px 0;
          }

          a {
            text-decoration: none;
            color: inherit;

            &:hover,
            &:focus {
              outline: 0;
              text-decoration: underline;
            }
          }

          @media ${ (props) => props.theme.breakpoints.devices.min.td } {
              padding-right: ${ (props) =>
                props.renderAokBenefits ? `170px` : `120px` };
          }
        }

        .address {

          //doctors && hospital @ desktop mode as column
          .address-column {
            display: flex;
            flex-direction: column;

            .opacity {
              opacity: 0;
            }

            .address-row {
              display: flex;
              flex-direction: row;
            }
          }

          .address-row {
              display: flex;
              flex-direction: row;
              margin-top: 10px;
              color: ${ (props) => props.theme.colors.grau2 };

              @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
                justify-content: space-between;
              }

              .address-container {
                display: flex;
                align-items: center;
                color: ${ (props) => props.theme.colors['standard-schwarz'] };

                  .tooltip {
                      position: relative;
                      top: 3px;
                      left: 10px;
                  }

                  .address-zip-city {
                    white-space: nowrap;
                  }

                .icon-f-printer {
                  color: ${ (props) => props.theme.colors['panel-inner-border'] };
                  margin-right: 10px;
                }
              }

              .address-icon {
                  width: 16px;
                  height: 16px;
                  fill: currentColor;
                  margin-right: 10px;
                  color: ${ (props) => props.theme.colors.grau2 };

                  .icon-grey {
                    color:  ${ (props) => props.theme.colors.iconGrau2 };
                  }

                  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
                    margin-right: 15px;
                  }

                  &::before {
                    vertical-align: inherit;
                  }
                }

              &.is-right {
                justify-content: flex-end;
              }

              .address-distance {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  margin-left: 20px;
                  color: ${ (props) => props.theme.colors.grau2 };

                  [class*="icon-"] {
                    margin-right: 10px;

                    ::before {
                      color: ${ (props) => props.theme.colors['icon-grau2'] };
                    }
                  }

                .tooltip {
                  margin-top: 3px;
                  margin-left: 10px;
                }
              }

              .benefit {
                  display: flex;
                  align-items: center;
                  padding: 10px 0;
                  margin-right: ${ (props) => (props.isMobile ? '0' : '30px') };

                  &.is-right {
                    margin-left: auto;
                  }

                  .benefit-text {
                    color: ${ (props) => props.theme.colors['aok-gruen'] };
                    margin-right: 10px;
                  }
              }

          }

          .midwives-contact {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

              @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
                flex-direction: column;
              }

              .address-row {
                display: flex;

                @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
                  margin: 5px 0;
                  flex-direction: column;
                }

                > span {
                  display: flex;
                  flex-direction: row;
                  margin-right: 30px;
                }
              }
          }


          .with-route-btn {
            justify-content: space-between;

              @media ${ (props) => props.theme.breakpoints.devices.max.sm } {
                flex-direction: column;
              }

              .address-container {
                  margin-bottom: 13px;
              }

            .result-tile-navigation-btn {
              margin-left: auto;

              > button {
                  margin: 0;
              }

              a {
                  font-size: 18px;
                  font-weight: 300;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.39;
                  letter-spacing: normal;

                  > span {
                      margin-left: 15px;

                      svg {
                          color: ${ (props) =>
                            props.theme.colors['panel-inner-border'] };
                      }
                  }
              }
            }
          }
      }
    }
  }

      .header-row {
          position: absolute;
          top: 5px;
          right: 0;
          display: flex;
          align-items: center;
          background: ${ (props) => props.theme.colors.weiss };
      }

      .benefit {
        display: flex;
        align-items: center;
        margin-right: ${ (props) => (props.isMobile ? '0' : '30px') };

        &.is-right {
          margin-left: auto;
        }

        .benefit-text {
          color: ${ (props) => props.theme.colors['aok-gruen'] };
          margin-right: 10px;
        }
      }
  }

  .no-min-height {
      min-height: auto;
      padding: 15px 20px 20px;
  }

  .asv-accordion {
      background: ${ (props) => props.theme.colors['hintergrund-prio2'] };
  }

  .no-accordion-container {
    padding: 14px 30px 20px 30px;
      font-size: 16px;
      font-weight: 300;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.44;
      letter-spacing: normal;
      color: ${ (props) => props.theme.colors['standard-schwarz'] };

    .no-accordion-container-row {
      display: flex;
      flex-direction: row;

      @media ${ (props) => props.theme.breakpoints.devices.max.sm }, print {
        flex-direction: column;
      }

      &.top-padding{
          margin-top: 20px;
      }

      .row-title {
        width: 240px;
        display: flex;
        align-items: baseline;

        @media ${ (props) => props.theme.breakpoints.devices.max.sm }, print {
          margin-bottom: 10px;
        }

        .tooltip {
          margin-left: 10px;
          top: 2px;
        }
      }

      .row-content {
        width: 100%;

        .ambulances-levels {
          list-style: none;
          padding: 0;
          margin: 0;

          > li {
            margin: 0;
          }
        }
      }
    }

    &.small-padding{
      padding: 14px 30px 22px 29px;
    }
`

// detail view link
export const DetailLink = styled(
  ({ component: LinkComponent = 'a', ...other }) => <LinkComponent { ...other } />
)`
  position: absolute;
  bottom: 20px;
  right: 20px;
  color: ${ (props) => props.theme.colors['aok-gruen'] };
  display: flex;
  align-items: center;

  .DetailLinkText {
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: normal;
  }

  > span {
    margin-left: 15px;
  }

  // required for IE11
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
`

export const DetailIcon = styled((props) => <Icon { ...props } />)`
  color: ${ (props) => props.theme.colors['aok-gruen'] };

  @media print {
    display: none;
  }
`

// bookmark icon
export const Bookmark = styled.div`
  display: inline-block;
  background: ${ (props) => props.theme.colors['hintergrund-prio3'] };
  border-top-left-radius: 22px;
  border-bottom-left-radius: 22px;
  z-index: ${ (props) => props.theme.zIndices.overlay };
  transition: right 0.2s ease-out;
`

export const BookmarkButton = styled.button`
  padding: 10px 15px 10px 5px;
  border: 0;
  background: transparent;
  font-weight: 200;
  cursor: pointer;
  display: flex;
  align-items: center;

  &::before {
    color: ${ (props) => props.theme.colors.grau2 };
    padding: 0 8px;
    display: inline-block;
    font: normal normal normal 14.54545px 'aok-icons-functional';
    font-size: 24px !important;
    line-height: 1;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transform: translate(0, 0);
    content: '${ (props) => (props.isBooked ? '' : '') }';
    vertical-align: middle;
  }

  &:focus {
    outline: 0;
  }
`

export const Accordion = styled.div`
  background: ${ (props) => props.theme.colors['content-bg-secondary'] };
`

export const AccordionPanelButton = styled.div`
  position: relative;
  width: 100%;
  line-height: 1;
  text-align: left;
  font-weight: 200;
  padding: 15px 20px;
  cursor: ${ (props) => (props.enabled ? 'pointer' : 'auto') };
  border-top: solid 1px
    ${ (props) => props.theme.colors['divider-detail-link-list'] };

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    padding: 15px 30px;
  }

  & > .accordion-icon {
    fill: currentColor;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 50%;
    right: 12px;
    margin-top: -0.5em;
    color: ${ (props) => props.theme.colors['panel-inner-border'] };
    transition: 0.3s transform ease-out;
    transform-origin: center center;
    display: ${ (props) => (props.enabled ? 'inline-block' : 'none') };
  }

  :focus {
    outline: 0;
  }

  &[aria-expanded='true'] {
    & > .accordion-icon {
      transform: rotate(180deg);
    }
  }
`

export const AccordionPanelBody = styled.div`
  animation: none !important;
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(1, 0, 1, 0);
  height: auto;
  max-height: 9999px;

  &.collapsed {
    max-height: 0;
    transition: max-height 0.35s cubic-bezier(0, 1, 0, 1);
  }

  border-top: 0;
`

export const AccordionContentWrapper = styled.div`
  padding: ${ (props) => (props.withOutPadding ? '0px' : '0 20px 15px') };

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    padding: ${ (props) => (props.withOutPadding ? '0px' : '0 30px 15px') };
  }

  .accordion-navigation-btn {
    display: flex;
    justify-content: flex-end;
    padding: 0;

    > a {
      color: ${ (props) => props.theme.colors['standard-schwarz'] };

      > span:before {
        margin-left: 15px;
        color: ${ (props) => props.theme.colors['panel-inner-border'] };
      }
    }
  }
`

export const AccordionRow = styled.div`
  display: flex;
  flex-direction: row;

  @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
    flex-direction: column;
  }

  & + & {
    margin-top: 20px;
  }

  & > div {
    padding: 0 5px;

    &:last-child {
      padding-right: 0;
      margin-right: ${ (props) => (props.changeItemSizes ? '0px' : '15px') };
    }
    &:first-child {
      padding-left: 0;
    }
  }

  //left row part (mostly label)
  > div:first-child {
    width: ${ (props) => (props.changeItemSizes ? '70%' : '45%') };
    @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
      width: 100%;
      margin: 5px 0;
    }
  }

  //right row part (mostly label)
  > div:last-child.fullSize {
    width: 100%;
  }

  > div:last-child:not(.fullSize) {
    width: ${ (props) => (props.changeItemSizes ? '30%' : '55%') };
    white-space: ${ (props) => (props.changeItemSizes ? 'pre' : 'inherit') };

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;

    > div:first-child {
      margin-right: ${ (props) => (props.changeItemSizes ? '0px' : '10px') };
      display: ${ (props) => (props.changeItemSizes ? 'block' : 'inherit') };
    }

    @media ${ (props) => props.theme.breakpoints.devices.max.md } {
      white-space: ${ (props) => (props.changeItemSizes ? 'normal' : 'inherit') };
    }

    @media ${ (props) => props.theme.breakpoints.devices.max.xs } {
      width: 100%;
      margin: 5px 0;
    }
  }

  .message-no-peq {
    margin-bottom: 0;
  }
`

export const AccordionRowItem = styled.div`
  display: table-cell;
  vertical-align: middle;

  &.space-between {
    justify-content: space-between;

    strong {
      margin-right: 10px;
    }
  }

  > span:first-child {
    margin-right: 10px;
  }

  > strong,
  > div > strong {
    margin-right: 10px;
  }

  .tooltip {
    > span:before {
      position: relative;
      top: 2px;
    }

    &.treatment {
      left: 10px;
    }
  }

  a.more-link {
    display: inline-block;
    cursor: pointer;
    color: ${ (props) => props.theme.colors['aok-gruen'] };
    text-decoration: none;
  }

  .indicators-representation {
    cursor: pointer;
    text-decoration: underline;
  }

  .qsr-details {
    display: flex;
    flex-direction: column;

    &.with-margin {
      margin: 10px 0 0;
    }

    .indicator-info {
      margin: 10px 5px 0;

      .tooltip {
        margin-left: 10px;
      }
    }
  }

  .bar-graph-average-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-right: 0;

    > div:first-child {
      max-width: 245px;
    }

    .average-label {
      font-size: 17px;
      line-height: 21px;
      padding-left: 10px;
      width: auto;
      hyphens: auto;
    }
  }
`
